import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EntidadEmpresarialEntity, ServicioEntidadService } from 'src/app/services/servicio-entidad.service';
import { LoginEntity } from 'src/app/services/servicio-login.service';
import { ServicioParametroSimensService } from 'src/app/services/servicio-parametro-simens.service';
import { ParametroRecordatorioEntity, RecordatorioCitasEntity, ServicioRecordatorioCitasService } from 'src/app/services/servicio-recordatorio-citas.service';

@Component({
  selector: 'app-reporte-recordatorio-citas-pos',
  templateUrl: './reporte-recordatorio-citas-pos.component.html',
  styleUrls: ['./reporte-recordatorio-citas-pos.component.css']
})
export class ReporteRecordatorioCitasPosComponent implements OnInit {

  private parametros: ParametroRecordatorioEntity = {
    codigoBaseDatos: '',
    uncoSede: 0,
    uncoLogin: 0,
    uncoCita: 0
  };

  public error: boolean;
  public loading: boolean;
  public informacionAdicional: string;
  public mensajeError: string;

  public entidadEmpresarial: EntidadEmpresarialEntity;
  public usuario: LoginEntity;
  public data: RecordatorioCitasEntity;

  constructor(private servicioRecordatorio: ServicioRecordatorioCitasService,
              private servicioEntidad: ServicioEntidadService,
              private servicioSimens: ServicioParametroSimensService,
              private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe((params: any) => {
      this.parametros.codigoBaseDatos = params.codigoBaseDatos;
      this.parametros.uncoSede = Number(params.uncoSede);
      this.parametros.uncoLogin = Number(params.uncoLogin);
      this.parametros.uncoCita = Number(params.uncoCirugia);
    })
  }

  ngOnInit() {
    console.log('Inicia el reporte')
    this.getEntidadEmpresarial();
  }

  private async getEntidadEmpresarial() {
    this.loading = true;
    const response = await this.servicioEntidad.getEntidadEmpresarial(this.parametros.codigoBaseDatos, this.parametros.uncoSede);
    response.subscribe((data: any) => {
      if (data != null) {
        this.entidadEmpresarial = data[0];
        this.getDataRecordatorio();
      } else {
        this.mensajeError = 'No fue posible obtener información de la entidad, error RRC-001.';
        this.loading = false;
        this.error = true;
        console.log('Error entidad empresarial')
      }
    }, (error: any) => {
      this.error = true;
      this.loading = false;
      console.log(error);
      this.mensajeError = 'No fue posible obtener información de la entidad, excepción RRC-001.';
    })
  }

  /*private async getUsuario() {
    const response = await this.servicioUsuario.getUsuario(this.parametros.codigoBaseDatos, this.parametros.uncoLogin);

    response.subscribe((data: any) => {
      console.log('Response usuario: ', data);
      if (data && Array.isArray(data)) {
        this.usuario = data[0];
        console.log('Usuario', this.usuario);
        this.getDataRecordatorio();
      } else {
        this.error = true;
        this.loading = false;
        this.mensajeError = 'No fue posible obtener información del usuario, error RRC-002.';
      }
    }, (error: any) => {
      this.error = true;
      this.loading = false;
      console.log(error);
      this.mensajeError = 'No fue posible obtener información del usuario, excepción RRC-002.';
    })
  }*/

  private async getDataRecordatorio() {
    const response = await this.servicioRecordatorio.getDataRecordatorioCitas(this.parametros.codigoBaseDatos, String(this.parametros.uncoCita));
    response.subscribe((data: any) => {
      if (data != null) {
        this.data = data[0]
        this.getParametroSimens();
      } else {
        this.error = true;
        this.loading = false;
        this.mensajeError = 'No fue posible obtener información de la cita, error RRC-003.';
      }
    }, (error: any) => {
      console.log(error);
      this.error = true;
      this.loading = false;
      this.mensajeError = 'No fue posible obtener información de la cita, excepción RRC-003.';
    })
  }

  private async getParametroSimens() {
    const response = await this.servicioSimens.getParametroSimensBySede(this.parametros.codigoBaseDatos, Number(this.parametros.uncoSede));
    response.subscribe((data: any) => {
      this.informacionAdicional = data && data.infoAdicionalRecordatorioCitas ? data.infoAdicionalRecordatorioCitas : '';
      this.loading = false;
      this.error = false;
    }, (error: any) => {
      console.log(error);
      this.error = true;
      this.loading = false;
      this.mensajeError = 'No fue posible obtener información adicional de la cita, excepción RRC-004.';
    })
  }

  public getPrint() {
      let printContents: any, popupWin: any;
  
      printContents = document.getElementById('recordatorio-print').innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
  
      popupWin.document.write(`
        <html>
          <head>
            <title> Standard Health | Reportes </title>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
            <style>
              /* Tamaños fuentes */
  
              .font-title {
                  font-size: 150px;
              }
  
              .font-subtitle {
                  font-size: 30px;
              }
  
              .font-normal {
                  font-size: 16px;
              }
            </style>
          </head>
          <body onload="window.print();window.close()">${ printContents }</body>
        </html>`
      );
  
      popupWin.document.close();
  }

  public generate() {
    this.getEntidadEmpresarial();
  }

}
